export default "__VITE_ASSET__6EmuYTzD__"